import React from "react";
import { connect } from "react-redux";
import 'rc-slider/assets/index.css';
import {
  Input,
  Row,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Col,
  Label,
} from "reactstrap";
import SystemLabel from "../../../../../../system/SystemLabel/SystemLabel";
import { tempLangConverter } from "../../../../../../helpers/lanugageHelper";
import { deepClone } from "../../../../../../helpers/objectHelper";
import { formActions } from "../../../../../../store/actions/cms/form/form.action";
import JirangoSwitch from "../../../../../../components/UI/Switch/JirangoSwitch";


class OptionSettings extends React.Component {

  handleSoftUpdate = (option) => {
    const { dispatch } = this.props;
    const element = deepClone(this.props.selectedElement);
    let opt = element.props.options.find(o => o.optionId === option.optionId && o.sortOrder === option.sortOrder);
    let indexOf = element.props.options.indexOf(opt)
    element.props.options[indexOf] = option;
    element.props.options[indexOf].isChanged = true;

    dispatch(formActions.updateFormElement(element));
  };
  handleChange = (e, val, path) => {
    const names = path.split(".");
    const selectedOption = deepClone(this.props.selectedOption);
    let value = val ? val : e.target.value;
    if (names.length === 1) {
      selectedOption[names[0]] = value;
      selectedOption.isChanged = true;
    }
    if (names.length === 2) {
      selectedOption[names[0]][names[1]] = value;
      selectedOption.isChanged = true;
    }
    if (names.length === 3) {
      selectedOption[names[0]][names[1]][names[2]] = value;
      selectedOption.isChanged = true;
    }
    if (names.length === 4) {
      selectedOption[names[0]][names[1]][names[2]][names[3]] = value;
      selectedOption.isChanged = true;
    }
    this.handleSoftUpdate(selectedOption)
  }
  render() {
    const { selectedOption } = this.props;
    if (!selectedOption) return null;
    return (
      <React.Fragment>
        <div>
          <div style={{ paddingTop: "10px" }}>
            <Row
              style={{
                justifyContent: "center",
                marginLeft: "2px",
                width: "100%"
              }}
            >
              <Col>
                <Label>
                  <SystemLabel name="OptionTitle" />
                </Label>
                {selectedOption.labels.map((l, index) => {
                  return (
                    <React.Fragment key={index}>
                      <InputGroup className="mb-3">
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className={`flag-icon flag-icon-${tempLangConverter(l.languageCode)}`} />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="text"
                          value={selectedOption.labels[index].text}
                          autoComplete="jirango-nofill"
                          onChange={e =>
                            this.handleChange(e, null, `labels.${index}.text`)
                          }
                        />
                      </InputGroup>
                    </React.Fragment>
                  );
                })}
              </Col>
            </Row>
          </div>
          <hr />
          <Row>
            <Col
              className="list-setting-item-title"
              style={{ display: "inline-flex" }}
            >
              <Label>
                <SystemLabel name="IsPreChecked" />
              </Label>
            </Col>
            <Col style={{ textAlign: "right"}}>
              <JirangoSwitch
                onChange={e => this.handleChange(null, !selectedOption.preChecked, `preChecked`)}
                isChecked={
                  selectedOption.preChecked !== true
                    ? false
                    : true
                }
              />
            </Col>
          </Row>
          <br/>
          <Row>
            <Col
              className="list-setting-item-title"
              style={{ display: "inline-flex" }}
            >
              <Label>
                <SystemLabel name="IsReadonly" />
              </Label>
            </Col>
            <Col style={{ textAlign: "right"}}>
              <JirangoSwitch
                onChange={e => this.handleChange(null, !selectedOption.readonly, `readonly`)}
                isChecked={
                  selectedOption.readonly !== true
                    ? false
                    : true
                }
              />
            </Col>
          </Row>
          <hr />
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    form: state.form,
    selectedElement: state.form.selectedElement,
    selectedOption: state.form.selectedOption,
  };
}

export default connect(mapStateToProps)(OptionSettings);
